import {Component, OnInit} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
    selector:'Notfound404Component',
     templateUrl:'notfound404.component.html'
})
export class Notfound404Component implements OnInit{

    ngOnInit(): void {
        this.SetPageMetaData();
    }

    constructor(private titleService: Title, private metaService: Meta) {
    }

    SetPageMetaData() {
        this.titleService.setTitle('404 - Not Found');
        this.metaService.updateTag({ name: 'description', content: '404 - Not Found' });
        this.metaService.updateTag({ name: 'keywords', content: '404 - Not Found' });
    }
}